import axios from "../../interceptors/axiosInterceptor";
import {
  CREATE_UPDATE_DELIVERY_DATE_URL,
  GET_WAREHOUSE_URL,
  FETCH_WAREHOUSE_DELIVERY_CONFIG,
} from "../../config/Url";
import {
  IGetQueryParams,
  IAddUpdateDeliveryDatePageState,
  IWarehouseCategory,
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import { normalizeWarehouse } from "normalizer/DeliveryDateNormalizer";

export const fetchWarehouseDeliveryConfig = (id: string) =>
  new Promise<IAddUpdateDeliveryDatePageState>((resolve, reject) => {
    let url = FETCH_WAREHOUSE_DELIVERY_CONFIG.replace("{warehouseId}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        const data = response && response.data;
        resolve(data);
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const createUpdateWarehouseDeliveryConfig = (payload: any) =>
  new Promise<void>((resolve, reject) => {
    if (payload) {
      axios
        .post(CREATE_UPDATE_DELIVERY_DATE_URL, payload, getAuthOptions())
        .then((response) => resolve())
        .catch((error) => {
          const errorPayload = normalizeCatchErrors(error.response);
          reject(errorPayload);
        });
    }
  });

export const fetchByCityWareHouseListApiCall = (
  cityId?: string,
  queryParam?: IGetQueryParams
) =>
  new Promise<Array<IWarehouseCategory>>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    if (cityId) {
      requestConfig.params = { cityId: cityId };
    }
    axios
      .get(GET_WAREHOUSE_URL, requestConfig)
      .then((response) => {
        const data = response && response.data;
        resolve(normalizeWarehouse(data));
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
